/* eslint-disable react/no-multi-comp */
import { DOMAINS_WITHOUT_LINKING } from 'templates/seo';
import { PAGINATION } from 'server/routes/seo/constants';
import PlacesContainer from 'templates/landing-seo/places-container';
import React from 'react';
import SeoEstablishmentCardContainer from 'molecules/seo-establishment-card/container';
import TextSection from 'templates/landing-seo/text-section';


function textSection(module, index, domain, t) {
  return (
    <TextSection
      key={ index }
      className="-is-white"
      id={ module.href }
      level={ module.level }
      text={ module.text }
      title={ titlePagination(module, t) }
    />
  );
}

function titlePagination(module, t) {
  const pagination = ` ${t("page {pageNum} of {numPages}", { numPages: module.numPages, pageNum: module.numPage })}`;
  return module.data === PAGINATION ? module.title + pagination : module.title;
}

function establishments(module, index, domain, t) {
  return (
    <div id={ `establishments-${module.position}` }>
      { (module.title || module.text)
        && (
          <TextSection
            key={ index }
            id={ null }
            level={ module.level }
            text={ module.title ? module.text || null : null }
            title={ module.title || module.text }
          />
        )
      }
      <ul className="landing-page__establishments">
        { module.data.map((estab, i) => (
          estab.type === 'ad-inline'
            ? <div id="ad-inline" />
            : <SeoEstablishmentCardContainer key={ i } establishment={ estab } t={ t } />)) }
      </ul>
    </div>
  );
}

function relateds(module, index, domain) {
  if (DOMAINS_WITHOUT_LINKING.includes(domain)) return null;
  return <PlacesContainer key={ index } places={ module.data } />;
}

function paginator() {
  return null;
}

export default function renderDynamic(module, index, domain, t) {
  const dispatcher = {
    establishments,
    establishments_for_couples: establishments,
    establishments_for_families: establishments,
    establishments_for_pet_friendly: establishments,
    paginator,
    relateds,
    textSection,
  };
  return dispatcher[module.type](module, index, domain, t);
}
